export default __webpack_public_path__ + "images/CA.f923bea.png";